import { GUEST_REASONS } from 'src/features/cards/types';
import { cardMessages } from 'src/features/cards/utils/messages';
import { statisticsMessages } from 'src/features/statistics/utils';

import type { CURRENCIES } from 'src/features/payStations/types';

export type StatisticTotalOperations = {
    result_type: string;
    operator_id: string;
    operator_name: string;
    due_amount: number;
};

export type StatisticOperationDetails = {
    id: number;
    event_datetime: string;
    identifier: string;
    identifier_type: string;
    identifier_name: string;
    due_amount: number;
    charge_plan_name: string;
    operator_id: string;
    operator_name: string;
    validation_reason: GUEST_REASONS;
    currency: CURRENCIES;
};

export enum VALIDATION_OPERATIONS_EXPORT_PROPS {
    OPERATOR_NAME = 'operator_name',
    IDENTIFIER = 'identifier',
    IDENTIFIER_TYPE = 'identifier_type',
    EVENT_DATETIME = 'event_datetime',
    TIME = 'time',
    DUE_AMOUNT = 'due_amount',
    CURRENCY = 'currency',
    CHARGE_PLAN_NAME = 'charge_plan_name',
    VALIDATION_REASON = 'validation_reason',
}

export const VALIDATION_OPERATIONS_EXPORT_MESSAGES_MAP = {
    [VALIDATION_OPERATIONS_EXPORT_PROPS.OPERATOR_NAME]: cardMessages.cardTypeOperator,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.IDENTIFIER]: cardMessages.cardNumber,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.TIME]: statisticsMessages.hour,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.IDENTIFIER_TYPE]: cardMessages.cardType,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.EVENT_DATETIME]: statisticsMessages.date,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.DUE_AMOUNT]: cardMessages.dueAmount,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.CURRENCY]: statisticsMessages.currency,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.CHARGE_PLAN_NAME]: cardMessages.chargePlan,
    [VALIDATION_OPERATIONS_EXPORT_PROPS.VALIDATION_REASON]: statisticsMessages.validationReason,
};
